import es from "./es";
import en from "./en";

const browserLanguage = (
    navigator.language ||
    navigator.userLanguage ||
    "es"
).toLowerCase();

const language = browserLanguage.startsWith("en") ? "en" : "es";

const translations = language === "en" ? en : es;

const t = (key) => {
    return key.split(".").reduce((obj, property) => {
        return obj && obj[property];
    }, translations);
};

export { t, language };